module.exports = {
  SET_PHONE_NUMBER: 'SET_PHONE_NUMBER'
};
